import React from "react";
import { Button } from "react-bootstrap";

interface LoadingButtonProps {
  isLoading: boolean;
  children: React.ReactNode;
  variant?: string;
  type?: "button" | "submit" | "reset";
  disabled?: boolean;
  style?: React.CSSProperties;
  onClick?: () => void;
}

const LoadingButton: React.FC<LoadingButtonProps> = ({
  isLoading,
  children,
  variant = "primary",
  type = "button",
  disabled = false,
  style = {},
  onClick
}) => {
  return (
    <Button
      type={type}
      variant={variant}
      disabled={isLoading || disabled}
      onClick={onClick}
      style={{ ...style, display: "block" }} // <-- buraya display block eklendi
    >
      {isLoading ? (
        <>
          <span
            className="spinner-border spinner-border-sm me-2"
            role="status"
            aria-hidden="true"
          ></span>
          İşlem Yapılıyor...
        </>
      ) : (
        children
      )}
    </Button>
  );
};


export default LoadingButton;
